"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Energy;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _CharacterStatsWindowModule = _interopRequireDefault(require("../../CharacterStatsWindow.module.scss"));

var _CharacterStatsWindow = _interopRequireDefault(require("../../CharacterStatsWindow.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Energy(_ref) {
  var energy = _ref.energy;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var hp = energy.hp,
      hpMax = energy.hpMax,
      mp = energy.mp,
      mpMax = energy.mpMax,
      sp = energy.sp,
      spMax = energy.spMax;
  /*
    TODO
    const isHpColorized={colorizedHp}
    const isMpColorized={colorizedMp}
    const isSpColorized={colorizedSp}
    */

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _CharacterStatsWindowModule.default.energy
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.hp, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.hp)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.hp, " ").concat(_CharacterStatsWindowModule.default.value)
  }, hp, " / ", hpMax), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.mp, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.mp)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.mp, " ").concat(_CharacterStatsWindowModule.default.value)
  }, mp, " / ", mpMax), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.sp, " ").concat(_CharacterStatsWindowModule.default.title)
  }, formatMessage(_CharacterStatsWindow.default.sp)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CharacterStatsWindowModule.default.sp, " ").concat(_CharacterStatsWindowModule.default.value)
  }, sp, " / ", spMax));
}